require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-not-so-naive-bayes.json") })
        }
      }, "path---posts-not-so-naive-bayes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-not-so-naive-bayes!./.cache/json/posts-not-so-naive-bayes.json
// module id = 400
// module chunks = 231608221292675